// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_rTG","cls2":"SuggestionCard-cls2_zn7 SuggestionCard-cls1_rTG","small":"SuggestionCard-small__pZ"};